import TextField, { TextFieldSize } from '@/components/molecules/TextField';
import * as Yup from 'yup';
import * as S from './styles';
import { CSSProperties, useState } from 'react';
import IndicadorValidacaoCampo from '@/components/molecules/IndicadorValidacaoCampo';
import IconButton from '@/components/atoms/IconButton';
import { IconeOlho } from '@/components/atoms/Icones/IconeOlho';
import { IconeOlhoFechado } from '@/components/atoms/Icones/IconeOlhoFechado';

interface TextFieldCadastroSenhaProps {
  // @ts-expect-error Valor Generico
  // eslint-disable-next-line no-undef
  $errors: FieldErrors<T>;
  // @ts-expect-error Valor Generico
  // eslint-disable-next-line no-undef
  $field: ControllerRenderProps<T, 'senha'>;
  inputSize?: TextFieldSize;
  style?: CSSProperties;
  label?: string;
}

export const senhaYupValidation = Yup.string()
  .required('A senha é obrigatória')
  .min(8, 'A senha deve ter no mínimo 8 caracteres')
  .matches(/[A-Z]/, 'A senha deve ter pelo menos uma letra maiúscula')
  .matches(/[a-z]/, 'A senha deve ter pelo menos uma letra minúscula')
  .matches(
    // eslint-disable-next-line no-useless-escape
    /[ `!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~]/,
    'A senha deve ter pelo menos um caractere especial',
  );

const validarRequisitosSenha = (senha: string) => ({
  temTamanhoMinimo: senha.length >= 8,
  temCharMaiusculo: senha.toLowerCase() !== senha,
  temCharMinusculo: senha.toUpperCase() !== senha,
  temCharEspecial:
    // eslint-disable-next-line no-useless-escape
    /[ `!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~]/.test(senha),
});

export function TextFieldCadastroSenha(props: TextFieldCadastroSenhaProps) {
  const { $errors, $field, inputSize = 2, style = {}, label = 'Senha' } = props;

  const [esconderTextoSenha, setEsconderTextoSenha] = useState(true);

  return (
    <TextField
      $size={inputSize}
      $variant="surface"
      $state="placeholder"
      $error={$errors.senha?.message ?? false}
      $label={label}
      $focusRing={false}
      $placeholder="Informe sua senha"
      $name={$field.name}
      $obrigatorio={true}
      $inputProps={{
        type: esconderTextoSenha ? 'password' : 'text',
        value: $field.value,
        onBlur: $field.onBlur,
        onChange: $field.onChange,
      }}
      $ItemEnd={
        <IconButton
          $size={inputSize}
          $variant="ghost"
          $color="neutral"
          $highContrast={true}
          $loading={false}
          $state="default"
          $focusRing={false}
          $Icon={esconderTextoSenha ? IconeOlhoFechado : IconeOlho}
          $onClick={() =>
            setEsconderTextoSenha((estadoAnterior) => !estadoAnterior)
          }
        />
      }
      $style={style}
    />
  );
}

export const confirmacaoSenhaYupValidation = Yup.string()
  .oneOf([Yup.ref('senha'), undefined], 'As senhas precisam ser iguais')
  .required('Confirmação de senha é obrigatória');

export function TextFieldCadastroConfirmarSenha(
  props: TextFieldCadastroSenhaProps,
) {
  const {
    $errors,
    $field,
    inputSize = 2,
    style = {},
    label = 'Confirmar senha',
  } = props;

  const [esconderTextoConfirmacaoSenha, setEsconderTextoConfirmacaoSenha] =
    useState(true);

  return (
    <TextField
      $size={inputSize}
      $variant="surface"
      $state="placeholder"
      $error={$errors.confirmacaoSenha?.message ?? false}
      $label={label}
      $focusRing={false}
      $placeholder="Confirme senha"
      $name={$field.name}
      $obrigatorio={true}
      $inputProps={{
        type: esconderTextoConfirmacaoSenha ? 'password' : 'text',
        value: $field.value,
        onBlur: $field.onBlur,
        onChange: $field.onChange,
      }}
      $ItemEnd={
        <IconButton
          $size={inputSize}
          $variant="ghost"
          $color="neutral"
          $highContrast={true}
          $loading={false}
          $state="default"
          $focusRing={false}
          $Icon={esconderTextoConfirmacaoSenha ? IconeOlhoFechado : IconeOlho}
          $onClick={() =>
            setEsconderTextoConfirmacaoSenha(
              (estadoAnterior) => !estadoAnterior,
            )
          }
        />
      }
      $style={style}
    />
  );
}

export function IndicadorValidacaoSenha(props: { valorCampoSenha: string }) {
  const { valorCampoSenha } = props;
  const requisitosSenha = validarRequisitosSenha(valorCampoSenha ?? '');

  return (
    <S.ListagemCondicionaisSenha>
      <IndicadorValidacaoCampo
        $condicao={requisitosSenha.temTamanhoMinimo}
        $text="Possuir no mínimo de 8 caracteres"
      />
      <IndicadorValidacaoCampo
        $condicao={requisitosSenha.temCharMaiusculo}
        $text="Possuir ao menos uma letra maiúscula"
      />
      <IndicadorValidacaoCampo
        $condicao={requisitosSenha.temCharMinusculo}
        $text="Possuir ao menos uma letra minúscula"
      />
      <IndicadorValidacaoCampo
        $condicao={requisitosSenha.temCharEspecial}
        $text="Possuir ao menos um caractere especial (ex: @, #, $)"
      />
    </S.ListagemCondicionaisSenha>
  );
}
